<template>
  <g>
    <g clip-path="url(#clip0_15_601)">
      <path
        d="M18.7 12.4002C18.42 12.2402 18.13 12.1102 17.84 12.0002C18.13 11.8902 18.42 11.7602 18.7 11.6002C20.62 10.4902 21.69 8.48018 21.7 6.41018C19.91 5.38018 17.63 5.30018 15.7 6.41018C15.42 6.57018 15.16 6.76018 14.92 6.95018C14.97 6.64018 15 6.32018 15 6.00018C15 3.78018 13.79 1.85018 12 0.810181C10.21 1.85018 8.99999 3.78018 8.99999 6.00018C8.99999 6.32018 9.02999 6.64018 9.07999 6.95018C8.83999 6.75018 8.57999 6.56018 8.29999 6.40018C6.37999 5.29018 4.09999 5.37018 2.29999 6.40018C2.29999 8.47018 3.36999 10.4802 5.29999 11.5902C5.57999 11.7502 5.86999 11.8802 6.15999 11.9902C5.86999 12.1002 5.57999 12.2302 5.29999 12.3902C3.37999 13.5002 2.30999 15.5102 2.29999 17.5802C4.08999 18.6102 6.36999 18.6902 8.29999 17.5802C8.57999 17.4202 8.83999 17.2302 9.07999 17.0402C9.02999 17.3602 8.99999 17.6802 8.99999 18.0002C8.99999 20.2202 10.21 22.1502 12 23.1902C13.79 22.1502 15 20.2202 15 18.0002C15 17.6802 14.97 17.3602 14.92 17.0502C15.16 17.2502 15.42 17.4302 15.7 17.5902C17.62 18.7002 19.9 18.6202 21.7 17.5902C21.69 15.5202 20.62 13.5102 18.7 12.4002ZM12 16.0002C9.78999 16.0002 7.99999 14.2102 7.99999 12.0002C7.99999 9.79018 9.78999 8.00018 12 8.00018C14.21 8.00018 16 9.79018 16 12.0002C16 14.2102 14.21 16.0002 12 16.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_601">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
